import React from "react";
import styles from "./styles/DashboardCard.module.css";
import CountUp from "react-countup";

const DashboardCard = ({
  bg1 = "",
  bg2 = "",
  icon,
  number,
  text,
  compact = false,
  alert = false,
  onClick,
}) => {
  return (
    <div
      className={`${styles.Card} ${compact ? styles.compact : ""} ${
        alert ? styles.alert : ""
      } ${onClick ? styles.clickable : ""}`}
      style={{
        backgroundImage: `linear-gradient(0deg, ${bg1} 0%, ${bg2} 80%)`,
      }}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") onClick();
            }
          : undefined
      }
    >
      {icon ? <div className={`${styles.iconCard}`}>{icon}</div> : null}
      <div>
        <p className={`${compact ? "fs-4" : "fs-2"} fw-bold m-0`}>
          <CountUp end={Number(number) || 0} />
        </p>
        <p className={`${compact ? "fs-6" : "fs-5"} m-0`}>{text}</p>
      </div>
    </div>
  );
};

export default DashboardCard;
